
import { ElectricalAspectEntityDecoratorBase } from './electrical-aspect.decorator.base';


export class ElectricalAspectEntityDecorator extends ElectricalAspectEntityDecoratorBase {
  constructor() {
    super();
  }
}



